var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import VueDialog from "../../interface/IVueDialog";
import UpperPaymentService from '../../api/UpperPaymentService';
import ArtMsglist from '../../components/alert/ArtMsglist.vue';
import Uploader from '../../common/components/uploader';
var AddDialog = (function (_super) {
    __extends(AddDialog, _super);
    function AddDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.payment_type_list = [];
        _this.formData = {
            statement_order_ids: "",
            order_id: "",
            order_money: "",
            payment_time: "",
            payment_type: 1,
            is_tax_ticket: 1,
            order_icomment: "",
        };
        _this.imageUrl = [];
        return _this;
    }
    AddDialog.prototype.created = function () {
        this.service = UpperPaymentService.getInstance();
        this.formData.order_money = this.payment_money;
    };
    AddDialog.prototype.mounted = function () {
        this.paymentTypeList();
    };
    AddDialog.prototype.changeMoney = function (e) {
        if (this.formData.order_money) {
            this.formData.order_money = Math.floor(this.formData.order_money * 10000) / 10000;
        }
    };
    AddDialog.prototype.paymentTypeList = function () {
        var _this = this;
        this.service.getPaymentType().then(function (res) {
            if (res.data.success) {
                _this.payment_type_list = res.data.data;
            }
            else {
                _this.$message.error(res.data.msg);
            }
            ;
        }, function (err) {
            _this.$message.error(err.message);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    AddDialog.prototype.close = function () {
        this.$closeDialog();
    };
    AddDialog.prototype.submitData = function () {
        if (this.formData.order_money < 0) {
            this.$message.error("请输入大于0的数字");
            return;
        }
        ;
        if (this.formData.order_money > this.payment_money) {
            this.$message.error("当前付款金额超出应付总金额，请修改");
            return;
        }
        var payment_vouche_img = this.imageUrl.map(function (item) { return item.url; });
        this.formData.payment_voucher = payment_vouche_img.length ? payment_vouche_img.join(',') : '';
        if (this.formData.order_id) {
            this.update();
        }
        else {
            this.add();
        }
    };
    AddDialog.prototype.add = function () {
        var _this = this;
        this.service.create(this.formData).then(function (res) {
            if (res.data.code == 51) {
                var instance = _this.$dialog(ArtMsglist, {
                    data: {
                        msgData: res.data.data
                    }
                }, {
                    title: "提示",
                    width: 450,
                    height: 350
                }).instance;
            }
            else {
                _this.$message.success('添加成功！');
                _this.close();
                _this.$emit('ok');
            }
        }, function (err) {
            _this.$message.error(err.message);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    AddDialog.prototype.update = function () {
        var _this = this;
        this.service.update(this.formData).then(function (res) {
            if (res.data.success) {
                _this.$message.success('修改成功！');
                _this.close();
                _this.$emit('ok');
            }
            else {
                _this.$message.error(res.data.msg);
            }
            ;
        }, function (err) {
            _this.$message.error(err.message);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    AddDialog.prototype.normalizer = function (node) {
        return {
            id: node.id,
            label: node.name,
            children: node.children,
        };
    };
    AddDialog = __decorate([
        Component({
            components: {
                uploader: Uploader,
            },
        })
    ], AddDialog);
    return AddDialog;
}(VueDialog));
export default AddDialog;
